/**
 * Edition switch (ADR-018 Decision 4).
 *
 * A single codebase serves three editions — SaaS, on-prem container, and
 * native-Windows on-prem — differing only by (a) runtime config, (b) this
 * build-time flag, and (c) native packaging. On-prem installs do not need the
 * public marketing / landing surface, so those routes are excluded from the
 * build when ``VITE_EDITION=onprem``.
 *
 * DEFAULT = SaaS: when ``VITE_EDITION`` is unset (or anything other than
 * ``onprem``) the build keeps every marketing/landing route exactly as today.
 *
 * The comparison is written against the raw ``import.meta.env`` literal so that
 * Vite/Rollup can statically fold ``includeMarketing`` to ``false`` in the
 * on-prem build and drop the guarded marketing chunks via tree-shaking.
 */
export const EDITION: string =
  (import.meta.env.VITE_EDITION as string | undefined) ?? 'saas'

/** True for the on-prem edition (container or native Windows). */
export const isOnPremEdition: boolean =
  import.meta.env.VITE_EDITION === 'onprem'

/**
 * Whether the marketing / landing surface (Landing, Marketing/*, SimpleHome)
 * is part of this build. SaaS default = true; on-prem = false.
 */
export const includeMarketing: boolean =
  import.meta.env.VITE_EDITION !== 'onprem'

/** On-prem default landing when the public landing page is excluded. */
export const ONPREM_DEFAULT_ROUTE = '/projects'
